import { createAction, props } from '@ngrx/store';
import { ContractId, ContractList } from '../../interfaces';

enum ContractsActionsIds {
    loadList = '[Contract List] Load Contract List',
    resetList = '[Contract List] Reset Contract List',
    resetSelected = '[Contract List] Reset Contract Selected',
    setList = '[Contract List] Set Contract List',
    setSelected = '[Contract List] Set Contract Selected',
}

export const LoadContractsAction = createAction(
    ContractsActionsIds.loadList
);

export const ResetContractsAction = createAction(
    ContractsActionsIds.resetList
);

export const ResetContractSelectedIdAction = createAction(
    ContractsActionsIds.resetSelected
);

export const SetContractsAction = createAction(
    ContractsActionsIds.setList,
    props<ContractList>()
);

export const SetContractSelectedIdAction = createAction(
    ContractsActionsIds.setSelected,
    props<ContractId>()
);